import * as React from 'react';

interface DynamicSidebarProps {
    sideBarOptions: string[];
    localizedOptions: { [key: string]: string }
    selectedOptionRenderer: (option: string) => JSX.Element;
    selectedOption?: string;
}

interface DynamicSidebarState {
    selectedOption: string;
}

export class DynamicSidebar extends React.PureComponent<DynamicSidebarProps, DynamicSidebarState> {
    public constructor(props: DynamicSidebarProps) {
        super(props);

        this.state = {
            selectedOption: this.props.selectedOption ?? this.props.sideBarOptions[0]
        };
    }

    public render() {
        return (
            <div className="sidebar-detail">
                <div className="sidebar">
                    <nav>
                        <ul>
                            {this.props.sideBarOptions.map((option, navIndex) => (
                                <li key={navIndex} className={(this.state.selectedOption === option ? "active" : "")} onClick={e => this.sideBarNavItem_click(option)}>
                                    {this.props.localizedOptions[option] ?? option}</li>
                                ))}
                        </ul>
                    </nav>
                </div>
                <div className="detail">
                    {this.props.selectedOptionRenderer(this.state.selectedOption)}
                </div>
            </div>
        );
    }

    private sideBarNavItem_click = (option: string) => {
        this.setState({
            selectedOption: option
        })
    };
}